<script lang="ts" setup>
const props = withDefaults(
    defineProps<{
        loading?: boolean;
        link?: boolean;
        href?: string;
        target?: string;
        rel?: string;
        type?: "button" | "submit" | "reset";
        disabled?: boolean;
        typography?: string;
    }>(),
    {
        link: false,
        type: "button",
        disabled: false,
    }
);

const emit = defineEmits<{
    (e: "button-clicked", ev: MouseEvent): void;
}>();

function onClick(ev: MouseEvent) {
    if (props.loading || props.disabled) {
        ev.preventDefault();
        ev.stopPropagation();
        return;
    }
    emit("button-clicked", ev);
}
</script>

<template>
    <component
        :is="props.link ? 'a' : 'button'"
        class="group btn cursor-pointer"
        tabindex="0"
        :href="props.link ? props.href : undefined"
        :target="props.link ? props.target : undefined"
        :rel="props.link ? (props.rel ?? (props.target === '_blank' ? 'noopener noreferrer' : undefined)) : undefined"
        :type="!props.link ? props.type : undefined"
        :disabled="!props.link ? (props.disabled || props.loading) : undefined"
        @click="onClick"
    >
        <svg
            v-if="props.loading"
            :class="{ 'animate-spin': props.loading }"
            class="ml-1 mr-3 h-5 w-5 text-white"
            fill="none"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
            <path
                class="opacity-75"
                d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                fill="currentColor"
            />
        </svg>

        <template v-if="props.loading"> Processando </template>
        <template v-else><slot /></template>
    </component>
</template>
